import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { draftel_codecs_pack_terkk$_bundle_klizac } from './ter-draftel-codec-lib-terkk-bundle-klizac';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { ROUNDDOWN } from '../utils/excel-functions-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from './ter-protobomp-utils';
import tclocal from './ter-consts-local-lib';
import { js_utils } from '../utils/frfr-js-utils';


/*
TODO


*/

export const derDraftel_terkk_klizac_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_klizac.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    msirinaunutrasnja: virtel_m.msirinaunutrasnja,
    vrstaprofila: virtel_m.vrstaprofila,
    // msirinaspoljasnja: virtel_m.msirinaspoljasnja, // TODO PITANJE da li ovo treba?
    duzinamodula: virtel_m.duzinamodula,
    siframodula: virtel_m.siframodula // 2023-12-11 dodao jel mozda ce trebati
  };
  return pods_input_inherited;
};


// TODO cparams_combined uzeti materijale
export const _derivat_terkk_klizac_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  /*
  Podrazumevani materijali:
  Lim :
  Klizac TIP A (Svi delovi klizaca i omega i L profil)
  LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore nije HYGIENE:pro
  LC00000J -
  LIM PROHROM 1.50 - Kada tip komre jeste HYGIENE:pro
  
  Klizac TIP B (Svi delovi klizaca i omega i L profil i maska)
  LB00000J - LIM POCINKOVANI 1.50 - Kada je tip komore HYDRA:pro
  LC00000J - LIM PROHROM 1.50 - Kada nije HYDRA:pro
  
  Klizac TIP C ()
  LB00000J - LIM POCINKOVANI 1.50 - Kada je tip komore HYDRA:pro (Odnosi se na limove )
  LC00000J - LIM PROHROM 1.50 - Kada nije HYDRA:pro (Odnosi se na limove )
  LC00000K - LIM PROHROM 2.00 (Uvek je ovaj materijal za PLOČICA za montažu)
  Profil:
  P4040EA000C06000 - PROFIL SS KUTIJASTI 40X40 3.0 4040 SIROV (Uvek je ovaj materijal)
  */
  //
  // _default_materijali_v1 sluze da zadrze kompatibilnost sa starim sastavnicama pre cparams
  const _default_materijali_v1 = {
    klizactipa_materijal_lim_pocinkovani: "LB00000J", // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore nije HYGIENE:pro
    klizactipa_materijal_lim_prohrom: "LC00000J", // LC00000J - LIM PROHROM 1.50 - Kada tip komore jeste HYGIENE:pro
    klizactipb_materijal_lim_pocinkovani: "LB00000J", // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore jeste komore HYDRA:pro
    klizactipb_materijal_lim_prohrom: "LC00000J", // LC00000J - LIM PROHROM 1.50 - Kada tip komore nije HYDRA:pro
    klizactipc_materijal_lim_pocinkovani: "LB00000J", // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore jeste HYDRA:pro (Odnosi se na limove)
    klizactipc_materijal_lim_prohrom: "LC00000J", // LC00000J - LIM PROHROM 1.50 - Kada tip komore nije HYDRA:pro
    klizactipc_materijal_lim_plocica: "LC00000K", // LC00000K - LIM PROHROM 2.00 (Uvek je ovaj materijal za PLOČICA za montažu)
    klizactipc_materijal_profil: "P4040EA000C06000", // P4040EA000C06000 - PROFIL SS KUTIJASTI 40X40 3.0 4040 SIROV (Uvek je ovaj materijal)
  };
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  console.log('_cpci', _cpci);
  //
  let klizactipa_materijal_lim = null;
  if (tipkomore === "HYGIENE:pro") {
    // LC00000J - LIM PROHROM 1.50 - Kada tip komore jeste HYGIENE:pro
    // By cparmas
    klizactipa_materijal_lim = _cpci.klizactipa_materijal_lim_prohrom;
  } else {
    // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore nije HYGIENE:pro
    // By cparmas
    klizactipa_materijal_lim = _cpci.klizactipa_materijal_lim_pocinkovani;
  }
  //
  let klizactipb_materijal_lim = null;
  if (tipkomore === "HYDRA:pro") {
    // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore jeste komore HYDRA:pro
    // By cparmas
    klizactipb_materijal_lim = _cpci.klizactipb_materijal_lim_pocinkovani;
  } else {
    // LC00000J - LIM PROHROM 1.50 - Kada tip komore nije HYDRA:pro
    // By cparmas
    klizactipb_materijal_lim = _cpci.klizactipb_materijal_lim_prohrom;
  }
  //
  let klizactipc_materijal_lim = null;
  if (tipkomore === "HYDRA:pro") {
    // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore jeste HYDRA:pro (Odnosi se na limove)
    // By cparmas
    klizactipc_materijal_lim = _cpci.klizactipc_materijal_lim_pocinkovani;
  } else {
    // LC00000J - LIM PROHROM 1.50 - Kada tip komore nije HYDRA:pro
    // By cparmas
    klizactipc_materijal_lim = _cpci.klizactipc_materijal_lim_prohrom;
  }
  //
  const klizactipc_materijal_lim_plocica = _cpci.klizactipc_materijal_lim_plocica;
  const klizactipc_materijal_profil = _cpci.klizactipc_materijal_profil;
  //
  return {
    klizactipa_materijal_lim,
    klizactipb_materijal_lim,
    klizactipc_materijal_lim,
    klizactipc_materijal_lim_plocica,
    klizactipc_materijal_profil,
  };
};


//
const _derivat_klizac_naziv_klizaca_omega_a = (klizaciznadcega, tipkomore, msirinaunutrasnja, vrstaprofila, unutrasnjaoplata) => {
  let naziv = 'KLIZAC';
  if (klizaciznadcega === 'IZNADPANELA') {
    naziv += ' OMEGA OSNOVNI';
  } else {
    naziv += ' KUTIJA'; // ???
  }
  if (tipkomore === 'HYGIENE:pro') {
    naziv += ' PROHROM';
  } else {
    naziv += ' POCINKOVANI';
  }
  let _visina_20_ili_35 = '';
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    _visina_20_ili_35 = 35;
  }
  naziv += ' ' + msirinaunutrasnja + ' ' + _visina_20_ili_35;

  //
  return naziv;
};


//
export const _derivat_terkk_klizac_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 
  $TIPklizaca- označava tip klizača i može biti A, B, C
  $Visinaprofila- Označava visinu porfila komore može biti 20 i 35
  $Duzinaklizaca- označava dužinu klizača.
  $Materijal-označava materijal elementa i može biti SS za prohrom GS za pocinkovani lim,
  $DužinaLprofila- označava dužinu L profila koji se kači na omegu klizača,
  $DužinaMaske-označava dužinu maske,
  $StranaMaske-ukoliko se maska montira na omegu postoji leva i desna onda je oznaka MAL za levu i MAD za desnu masku ukoliko je na cev onda nazivu dodajemo oznaku MAC.
  $TipKadice- maske nisu iste za plitku i za standardnu kadicu, pa moramo i ovo da odvojimo po nazivu, za plitku kadicu je P za standardnu je S.
  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    tervrstaprofila_50_ili_70,
  } = protobomp_superdata;
  //
  if (tervrstaprofila_50_ili_70 === "50") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 20;
    _naziv_profil_komore_50_ili_70 = "P50";
  }
  if (tervrstaprofila_50_ili_70 === "70") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 35;
    _naziv_profil_komore_50_ili_70 = "P70";
  }
  //
  let klizac_polje_tip = null;
  if (tervrstaprofila_50_ili_70 === "50" || tervrstaprofila_50_ili_70 === "70") {
    /*
    Proračun razvijenih mera radi se pos ledećim formulama:
    ...

    Kada imamo Tip klizača C odnosno cev iznad kadice, dužina je kao i kod standardnog klizača. 

    Potrebno je dostaviti proračun za plitku masku. Proračun plitke maske isti je za P50 i P70: ((54.5+38.25)*((Dužina)-80))/2
    */
    /*
    Proračun površine elemenata nije tačan, proračun se računa preko formula kao u fajlu iz priloga. Ovaj deo bi dobro bilo da imamo otvoren da možemo da menjamo.
    Utrošci se ne računaju po formulama koje smo poslali.  Omega klizača u sastavljaču stoji 0,17 potrebno je kao po proračunu koji smo poslali 1,828*0,1226=0,224m2. L profil za 1,828*0,0514 iznosi 0,09m2. Maska klizača za TIP B i TIP C ((62,2+107,7)*((duzina)-80))/2
    */

    // sklop
    if (family === 'terkk$klizac/SKLOP_KLIZAC' || family === 'terkk$klizac/SKLOP_KLIZAC_A' || family === 'terkk$klizac/SKLOP_KLIZAC_B' || family === 'terkk$klizac/SKLOP_KLIZAC_C') {
      item.klizac_visina = _visina_20_ili_35; // DIRTY
      _naziv = item.naziv;
      const _sklop_naziv_sufix = SPACE + item.duzina + 'x' + item.klizac_visina + SPACE + _materijal;
      _naziv += _sklop_naziv_sufix; // TODO
      /*
        pbnode_family: 'terkk$klizac/SKLOP_KLIZAC',
        duzina: _duzina_omege, // TODO ???
        klizac_duzina: _duzina_omege, // TODO ???
        klizac_visina: _visina_20_ili_35,
      };
      let _temp_sklop;
      let _temp_pbnode;
      _temp_sklop = {
        ..._sklop_uzor,
        pbnode_family: 'terkk$klizac/SKLOP_KLIZAC',
        klizac_tip: 'A',
        // naziv: 'KLIZAC TIP A OSNOVNI',
        naziv: 'KLIZAC TIP A IZNAD PANELA',
      */
      if (item.klizac_tip === 'A') {
        if (_visina_20_ili_35 === 20) {
          klizac_polje_tip = 'A_20';
        }
        if (_visina_20_ili_35 === 35) {
          klizac_polje_tip = 'A_35';
        }
      }
      if (item.klizac_tip === 'B' || item.klizac_tip === 'C') {
        klizac_polje_tip = item.klizac_tip;
        if (item.klizac_tip === 'B') {
          if (_visina_20_ili_35 === 20) {
            klizac_polje_tip += '_20';
          }
          if (_visina_20_ili_35 === 35) {
            klizac_polje_tip += '_35';
          }
        }
        if (item.klizac_tip === 'C') {
          klizac_polje_tip += '_35'; // NJ: Tip C za sada uvek 35
        }
        if (js_utils.is_string_not_empty(item.klizac_strana_maske)) {
          // sa maskom
          if (item.klizac_strana_maske === 'LEVI') {
            klizac_polje_tip += '_MAL';
          }
          if (item.klizac_strana_maske === 'DESNI') {
            klizac_polje_tip += '_MAD';
          }
          if (item.klizac_strana_maske === 'DA') {
            klizac_polje_tip += '_MA';
          }
        } else {
          // bez maske
        }
        klizac_polje_tip += '_' + item.klizac_tip_kadice;
      }
    }
    // a
    if (family === 'terkk$klizac/LIM_OMEGA_A') {
      item.razvijenamera1 = item.dimenzija1;
      if (tervrstaprofila_50_ili_70 === "50") {
        /*
        Profil 50
        Iznad panela P01-09-A-20
        Utrošak omege P1 se računa po formuli 92,6*(dužina)
        Omega P1
        Razvijena 1 = Dužina
        Razvijena 2 =računa se po formuli 92,6*(Razvijena 1)
        */
        povrsina = 92.6 * item.razvijenamera1;
      }
      if (tervrstaprofila_50_ili_70 === "70") {
        /*
        Profil 70
        Iznad panela P01-09-A-35
        Utrošak omege P1 se računa po formuli 122,9*(dužina)
        Profil 70
        Iznad panela P01-09-A-35
        Omege P1
        Razvijena 1= Dužina
        Razvijena 2 = računa se po formuli 122,9*(Razvijena 1)
        */
        povrsina = 122.9 * item.razvijenamera1;
      }
      _tip_klizaca_abc = 'A';
      item.klizac_tip = 'A'; // DIRTY
      _sufix = 'P1';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'A_20_OMEGA';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'A_35_OMEGA';
      }
    }
    if (family === 'terkk$klizac/LIM_L_A') {
      item.razvijenamera1 = item.dimenzija1;
      if (tervrstaprofila_50_ili_70 === "50") {
        /*
        Utošak L profila P2 se računa po formuli 51.4*(dužina)
        L profila P2
        Razvijena 1 = Dužina
        Razvijena 2 = računa se po formuli 51.4*(Razvijena 1)
        */
        povrsina = 51.4 * item.razvijenamera1;
      }
      if (tervrstaprofila_50_ili_70 === "70") {
        /*
        Utošak L profila P2 se računa po formuli 51.4*(dužina)
        L profila P2
        Razvijena 1= Dužina
        Razvijena 2 = računa se po formuli 51.4*(Razvijena 1)
        */
        povrsina = 51.4 * item.razvijenamera1;
      }
      _tip_klizaca_abc = 'A';
      item.klizac_tip = 'A'; // DIRTY
      _sufix = 'P2';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'A_LPROFIL';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'A_LPROFIL';
      }
    }
    // b
    if (family === 'terkk$klizac/LIM_OMEGA_B') {
      item.razvijenamera1 = item.dimenzija1;
      if (tervrstaprofila_50_ili_70 === "50") {
        /*
        Iznad kadice P01-09-B-20
        Utrošak omege P1 se računa po formuli 92,6*(dužina)
        Omega P1
        Razvijena 1 = Dužina
        Razvijena 2 = računa se po formuli 92,6*(Razvijena 1)
        */
        povrsina = 92.6 * item.razvijenamera1;
      }
      if (tervrstaprofila_50_ili_70 === "70") {
        /*
        Iznad kadice P01-09-B-35
        Utrošak omege P1 se računa po formuli 122,9*(dužina)
        Omega P1
        Razvijena 1= Dužina
        Razvijena 2 = računa se po formuli 122,9*(Razvijena 1)
        */
        povrsina = 122.9 * item.razvijenamera1;
      }
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _sufix = 'P1';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_20_OMEGA';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_35_OMEGA';
      }
    }
    if (family === 'terkk$klizac/LIM_L_B') {
      item.razvijenamera1 = item.dimenzija1;
      if (tervrstaprofila_50_ili_70 === "50") {
        /*
        Utrošak L profila P2 se računa po formuli 51,4*(dužina-100)
        L profila P2
        Razvijena 1 = Dužina
        Razvijena 2 = Računa se po formuli 51,4*(Razvijena 1)
        */
        povrsina = 51.4 * (item.razvijenamera1 - 100);
      }
      if (tervrstaprofila_50_ili_70 === "70") {
        /*
        Utrošak L profila P2 se računa po formuli 51,4*(dužina-100)
        L profila P2
        Razvijena 1= Dužina
        Razvijena 2 = računa se po formuli 51,4*(Razvijena 1)
        */
        povrsina = 51.4 * (item.razvijenamera1 - 100);
      }
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _sufix = 'P2';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_LPROFIL';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_LPROFIL';
      }
    }
    if (family === 'terkk$klizac/MASKA_B_LEVA' || family === 'terkk$klizac/MASKA_B_DESNA') {
      /*
      Utrošak standardne maske P3 i P4 se računa po formuli ((62,2+107,7)(duzina)-48)/2
      Standardna maska P3 i P4
      Razvijena 1= Dužina
      Razvijena 2 = računa se po formuli ((62,2+107,7)*(Razvijena 1))/2
      */
      item.razvijenamera1 = item.dimenzija1;
      povrsina = ((62.2 + 107.7) * (item.razvijenamera1 - 48)) / 2;

    }
    if (family === 'terkk$klizac/MASKA_B_LEVA') {
      _tip_kadice = 'S'; // STANDARD
      item.klizac_tip_kadice = 'S'; // DIRTY
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _strana_maske = 'MAL';
      _sufix = 'P4';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_20_MASKAL_S';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_35_MASKAL_S';
      }
    }
    if (family === 'terkk$klizac/MASKA_B_DESNA') {
      _tip_kadice = 'S'; // STANDARD
      item.klizac_tip_kadice = 'S'; // DIRTY
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _strana_maske = 'MAD';
      _sufix = 'P3';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_20_MASKAD_S';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_35_MASKAD_S';
      }
    }
    if (family === 'terkk$klizac/MASKA_B_PLITKA_LEVA' || family === 'terkk$klizac/MASKA_B_PLITKA_DESNA') {
      // staro Potrebno je dostaviti proračun za plitku masku. Proračun plitke maske isti je za P50 i P70: ((54.5+38.25)*((Dužina)-80))/2
      /*
      Utrošak plitke maske P3 i P4 se računa po formuli ((54,2+38,2)(duzina)-48)/2
      Plitka maska P3 i P4
      Razvijena 1= Dužina
      Razvijena 2 = računa se po formuli ((54,2+38,2)*(Razvijena 1))/2
      */
      item.razvijenamera1 = item.dimenzija1;
      povrsina = ((54.2 + 38.2) * (item.razvijenamera1 - 48)) / 2;
    }
    if (family === 'terkk$klizac/MASKA_B_PLITKA_LEVA') {
      _tip_kadice = 'P'; // PLITKA
      item.klizac_tip_kadice = 'P'; // DIRTY
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _strana_maske = 'MAL';
      _sufix = 'P6';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_20_MASKAL_P';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_35_MASKAL_P';
      }
    }
    if (family === 'terkk$klizac/MASKA_B_PLITKA_DESNA') {
      _tip_kadice = 'P'; // PLITKA
      item.klizac_tip_kadice = 'P'; // DIRTY
      _tip_klizaca_abc = 'B';
      item.klizac_tip = 'B'; // DIRTY
      _strana_maske = 'MAD';
      _sufix = 'P5';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'B_20_MASKAD_P';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'B_35_MASKAD_P';
      }
    }
    // c
    if (family === 'terkk$klizac/PROFIL_KVAD_C') {
      // PRIMITIVE_TER_PROFIL
      // TODO CEV klizaca
      // Cev klizača: „Cev klizača“+$TIPklizača+$Dužinaklizača+$profilkomore(P50/P70)
      _tip_klizaca_abc = 'C';
      _naziv = "CEV KLIZACA" + SPACE + _tip_klizaca_abc + SPACE + item.duzina + SPACE + _naziv_profil_komore_50_ili_70 + SPACE + _materijal;
      _sufix = 'P1';
      /*
      Primer naziva za Kvadratni profil cev od klizaca tipa C:
      Profil klizača C 1218 P70 SS (nema razlika u imenu za ovaj profil kada je iznad plitke ili standardne)
      */
    }
    if (family === 'terkk$klizac/LIM_L_C') {
      /*
      Iznad kadice P01-09-C-35
      Utrošak L profila P2 se računa po formuli 51,4*(dužina-100)
      Iznad kadice P01-09-C-35
      L profil P2
      Razvijena 1= Dužina
      Razvijena 2 = računa se po formuli 51,4*(Razvijena 1)
      */
      item.razvijenamera1 = item.dimenzija1;
      povrsina = 51.4 * (item.razvijenamera1 - 100);
      _tip_klizaca_abc = 'C';
      item.klizac_tip = 'C'; // DIRTY
      _sufix = 'P2';
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'C_LPROFIL';
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'C_LPROFIL';
      }
    }
    if (family === 'terkk$klizac/MASKA_C' || family === 'terkk$klizac/MASKA_C_1_2' || family === 'terkk$klizac/MASKA_C_2_2') {
      /*
      Utrošak Standardne maske P3 i P4 se računa po formuli ((62,2+107,7)(duzina)-48)/2
      Standardna maska P3 i P4
      Razvijena 1= Dužina
      Razvijena 2 = računa se po formuli ((62,2+107,7)*(Razvijena 1))/2
      */
      item.razvijenamera1 = item.dimenzija1;
      povrsina = ((62.2 + 107.7) * (item.razvijenamera1 - 48)) / 2;
      _naziv_tip_kadice = 'STANDARDNA'; // STANDARD
      _tip_kadice = 'S'; // STANDARD
      item.klizac_tip_kadice = 'S'; // DIRTY
      _sufix = 'P3';
      if (family === 'terkk$klizac/MASKA_C_1_2') {
        _sufix += '.1';
      }
      if (family === 'terkk$klizac/MASKA_C_2_2') {
        _sufix += '.2';
      }
      item.klizac_tip = 'C'; // DIRTY
      // klizac_polje_tip = 'C_MASKA_' + _tip_kadice;
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'C_20_MASKA_' + _tip_kadice;
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'C_35_MASKA_' + _tip_kadice;
      }
    }
    if (family === 'terkk$klizac/MASKA_C_PLITKA' || family === 'terkk$klizac/MASKA_C_PLITKA_1_2' || family === 'terkk$klizac/MASKA_C_PLITKA_2_2') {
      /*
      Utrošak Plitke maske P3 i P4 se računa po formuli ((54,2+38,2)(duzina)-48)/2
      Plitka maska P3 i P4
      Razvijena 1= Dužina
      Razvijena 2 = računa se po formuli ((54,2+38,2)*(Razvijena 1))/2
      */
      item.razvijenamera1 = item.dimenzija1;
      povrsina = ((54.2 + 38.2) * (item.razvijenamera1 - 48)) / 2;
      _naziv_tip_kadice = 'PLITKA'; // PLITKA
      _tip_kadice = 'P'; // PLITKA
      item.klizac_tip_kadice = 'P'; // DIRTY
      _sufix = 'P4';
      if (family === 'terkk$klizac/MASKA_C_PLITKA_1_2') {
        _sufix += '.1';
      }
      if (family === 'terkk$klizac/MASKA_C_PLITKA_2_2') {
        _sufix += '.2';
      }
      item.klizac_tip = 'C'; // DIRTY
      // klizac_polje_tip = 'C_MASKA_' + _tip_kadice;
      if (_visina_20_ili_35 === 20) {
        klizac_polje_tip = 'C_20_MASKA_' + _tip_kadice;
      }
      if (_visina_20_ili_35 === 35) {
        klizac_polje_tip = 'C_35_MASKA_' + _tip_kadice;
      }
    }
    if (family === 'terkk$klizac/LIM_PLOCICA') {
      _sufix = 'P5';
      _cnc = "P01-09-C-P5";
      /*
      Primer naziva za pločicu prohromskog profila Tip C:
      Pločica klizača C 88x33
      */
      _naziv = "PLOCICA KLIZACA C" + SPACE + "88x33";
    }
    //
  }
  //
  if (klizac_polje_tip) {
    item.tip = klizac_polje_tip; // DIRTY
  }
  //
  /*
  Nazivi elemenata, pored CNC programa potrebno je generisati i nazive svakog elementa nazive je potrebno graditi na sličan način kao i CNC programe:
  Omega klizača: „Omega klizača“+$TIPklizača+$Dužinaklizača+$profilkomore(P50/P70) +$Materijal
  Cev klizača: „Cev klizača“+$TIPklizača+$Dužinaklizača+$profilkomore(P50/P70)
  L profil klizača: „L profil klizača“+$TIPklizača+$DužinaLprofila+$Materijal
  Maska klizača: „Maska klizača“+ -$TIPklizaca+$ DužinaMaske+$StranaMaske(leva/desna)+$TipKadice(standardna/plitka) +$Materijal

  Kod tipa C naziv CNC programa gradi se na isti način kao kod prethodnih tipova.
  */
  //
  if (family === 'terkk$klizac/LIM_OMEGA_A' || family === 'terkk$klizac/LIM_OMEGA_B') {
    // Omega klizača- „P01-09“+$TIPklizaca+$Visinaprofila+$Duzinaklizaca -$Materijal
    _cnc = "P01-09" + MINUS + _tip_klizaca_abc + MINUS + item.dimenzija2 + MINUS + item.dimenzija1 + MINUS + _materijal + MINUS + _sufix;
    // Omega klizača: „Omega klizača“+$TIPklizača+$Dužinaklizača+$profilkomore(P50/P70) +$Materijal
    _naziv = "OMEGA KLIZACA" + SPACE + _tip_klizaca_abc + SPACE + item.dimenzija1 + SPACE + _naziv_profil_komore_50_ili_70 + SPACE + _materijal;
  }
  if (family === 'terkk$klizac/LIM_L_A' || family === 'terkk$klizac/LIM_L_B' || family === 'terkk$klizac/LIM_L_C') {
    // L profil klizača- „P01-09“+$TIPklizaca+$DužinaLprofila+$Materijal
    _cnc = "P01-09" + MINUS + _tip_klizaca_abc + MINUS + item.dimenzija1 + MINUS + _materijal + MINUS + _sufix;
    // L profil klizača: „L profil klizača“+$TIPklizača+$DužinaLprofila+$Materijal
    _naziv = "L PROFIL KLIZACA" + SPACE + _tip_klizaca_abc + SPACE + item.dimenzija1 + SPACE + _materijal;
  }
  if (family === 'terkk$klizac/MASKA_B_LEVA' || family === 'terkk$klizac/MASKA_B_DESNA' || family === 'terkk$klizac/MASKA_B_PLITKA_LEVA' || family === 'terkk$klizac/MASKA_B_PLITKA_DESNA') {
    // Maska klizača- „P01-09“+$TIPklizaca+$Visinaprofila+$DužinaMaske+$StranaMaske+$TipKadice+$Materijal
    _cnc = "P01-09" + MINUS + _tip_klizaca_abc + MINUS + _visina_20_ili_35 + MINUS + item.dimenzija1 + MINUS + _strana_maske + MINUS + _tip_kadice + MINUS + _materijal + MINUS + _sufix;
    // Maska klizača: „Maska klizača“+ -$TIPklizaca+$ DužinaMaske+$StranaMaske(leva/desna)+$TipKadice(standardna/plitka) +$Materijal
    let _naziv_strana_maske = 'LEVA';
    if (_strana_maske === 'MAD') {
      _naziv_strana_maske = 'DESNA';
    }
    _naziv_tip_kadice = 'STANDARDNA';
    if (_tip_kadice === 'P') {
      _naziv_tip_kadice = 'PLITKA';
    }
    _naziv = "MASKA KLIZACA" + SPACE + _tip_klizaca_abc + SPACE + item.dimenzija1 + SPACE + _naziv_strana_maske + SPACE + _naziv_tip_kadice + SPACE + _materijal;
  }
  if (family === 'terkk$klizac/MASKA_C' || family === 'terkk$klizac/MASKA_C_1_2' || family === 'terkk$klizac/MASKA_C_2_2' || family === 'terkk$klizac/MASKA_C_PLITKA' || family === 'terkk$klizac/MASKA_C_PLITKA_1_2' || family === 'terkk$klizac/MASKA_C_PLITKA_2_2') {
    /*
    Primer naziva za masku C:
    Maska klizača C 1142 standardna SS
    Maska klizača C 1142 plitka SS
    */
    let _tip_klizaca_abc = 'C';
    _cnc = "P01-09" + MINUS + _tip_klizaca_abc + MINUS + _visina_20_ili_35 + MINUS + item.dimenzija1 + MINUS + _tip_kadice + MINUS + _materijal + MINUS + _sufix; // * IMPROVIZOVANO TODO
    _naziv = "MASKA KLIZACA" + SPACE + _tip_klizaca_abc + SPACE + item.dimenzija1 + SPACE + _naziv_tip_kadice + SPACE + _materijal;
    // NJ: jedan deo maske da ima u nazivu .1 a drugi de .2
    if (family === 'terkk$klizac/MASKA_C_1_2' || family === 'terkk$klizac/MASKA_C_PLITKA_1_2') {
      _naziv += SPACE + "1od2";
      // _cnc += '.2'; // SUFIX ne treba vec ima sufix
      item.ter_koji_deo_visedelnog = 1; // DIRTY
    }
    if (family === 'terkk$klizac/MASKA_C_2_2' || family === 'terkk$klizac/MASKA_C_PLITKA_2_2') {
      _naziv += SPACE + "2od2";
      // _cnc += '.2'; // SUFIX ne treba vec ima sufix
      item.ter_koji_deo_visedelnog = 2; // DIRTY
    }
  }
  //
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_klizac_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    msirinaunutrasnja,
    vrstaprofila,
    tipkomore,
  } = pods_input;
  const {
    klizactipa_materijal_lim,
    klizactipb_materijal_lim,
    klizactipc_materijal_lim,
    klizactipc_materijal_lim_plocica,
    klizactipc_materijal_profil,
    klizac_brojelemenataiznadpanela,
    klizac_brojelemenataiznadkadicestandardna,
    klizac_brojelemenataiznadkadiceplitka,
    klizac_kolikokadicastandardna,
    klizac_kolikokadicaplitka,
  } = state;
  // console.log('_derivat_terkk_klizac_izracunaj_za_step_protobomp', klizaciznadcega);
  //

  //
  // 1. Tip A Kolicina = Suma kolicina Iznad panela*4 + Iznad kadice standardne 2 + Iznad kadice plitke2
  let klizac_kolikoa = (4 * klizac_brojelemenataiznadpanela) + (2 * klizac_brojelemenataiznadkadicestandardna) + (2 * klizac_brojelemenataiznadkadiceplitka);
  //
  // 2. Tip B Kolicina, Tip C Kolicina...
  let klizac_kolikob;
  let klizac_kolikob_levi;
  let klizac_kolikob_desni;
  let klizac_kolikobplitka;
  let klizac_kolikobplitka_levi;
  let klizac_kolikobplitka_desni;
  let klizac_kolikoc;
  let klizac_kolikoc_krajnji;
  let klizac_kolikocplitka;
  let klizac_kolikocplitka_krajnji;
  if (msirinaunutrasnja > 1500) {
    // dobijamo klizace tipa C // NJ: klizači tip C se stvaraju kada je duzina kliuzaca veca od 1500
    klizac_kolikob_levi = 0;
    klizac_kolikob_desni = 0;
    klizac_kolikobplitka_levi = 0;
    klizac_kolikobplitka_desni = 0;
    klizac_kolikob = 0;
    klizac_kolikobplitka = 0;
    // proracun levih i desnih
    if (klizac_brojelemenataiznadkadicestandardna > 0) {
      klizac_kolikoc_krajnji = (2 * klizac_kolikokadicastandardna);
    }
    if (klizac_brojelemenataiznadkadiceplitka > 0) {
      klizac_kolikocplitka_krajnji = (2 * klizac_kolikokadicaplitka);
    }
    klizac_kolikoc = (2 * klizac_brojelemenataiznadkadicestandardna) - klizac_kolikoc_krajnji;
    klizac_kolikocplitka = (2 * klizac_brojelemenataiznadkadiceplitka) - klizac_kolikocplitka_krajnji;
  } else {
    // dobijamo klizace tipa B 
    //
    // proracun levih i desnih
    if (klizac_brojelemenataiznadkadicestandardna > 0) {
      klizac_kolikob_levi = klizac_kolikokadicastandardna;
      klizac_kolikob_desni = klizac_kolikokadicastandardna;
    }
    if (klizac_brojelemenataiznadkadiceplitka > 0) {
      klizac_kolikobplitka_levi = klizac_kolikokadicaplitka;
      klizac_kolikobplitka_desni = klizac_kolikokadicaplitka;
    }
    // klizac_kolikob = (2 * klizac_brojelemenataiznadkadicestandardna);
    klizac_kolikob = (2 * klizac_brojelemenataiznadkadicestandardna) - klizac_kolikob_levi - klizac_kolikob_desni;
    // klizac_kolikobplitka = (2 * klizac_brojelemenataiznadkadiceplitka);
    klizac_kolikobplitka = (2 * klizac_brojelemenataiznadkadiceplitka) - klizac_kolikobplitka_levi - klizac_kolikobplitka_desni;
    klizac_kolikoc = 0;
    klizac_kolikocplitka = 0;
    klizac_kolikoc_krajnji = 0;
    klizac_kolikocplitka_krajnji = 0;
  }
  //


  ////
  let _visina_20_ili_35 = -1;
  let _visina_maske = -99;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  // NJ: Visina omega profila je uvek 20mm ili 35mm zavisno od toga koji profil modula se koristi.
  if (tervrstaprofila_50_ili_70 === '50') {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    _visina_20_ili_35 = 35;
  }
  _visina_maske = _visina_20_ili_35;
  //
  const _NESTO_2mm = 2;
  //
  // Duzina = unutrasnja sirina komore - Ako je profil 50 -48, ako je profil 70 onda -78
  let _duzina_maske;
  if (tervrstaprofila_50_ili_70 === '50') {
    _duzina_maske = msirinaunutrasnja - 48;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    _duzina_maske = msirinaunutrasnja - 78;
  }
  //
  const _duzina_omege = msirinaunutrasnja - _NESTO_2mm;
  let _is_klizactipa_dvodelna_varijanta = false;
  let _klizactipa_dvodelni_child_kolicina = 1;
  if (_duzina_omege > 2440) {
    // NJ 2024-11-19: Imamo izmenu kod klizača TIP A. Kada je klizač TIP A iz dva dela, potrebno je da promenimo logiku količina. Do sada smo pravili 4 sklopa sa po dva elementa: Sada je potrebno da promenimo logiku i da pravimo 8 sklopa sa po jednim elementom.
    _is_klizactipa_dvodelna_varijanta = true;
    klizac_kolikoa = (klizac_kolikoa * 2);
    _klizactipa_dvodelni_child_kolicina = 1;
  }


  // TODO
  const protobomp_superdata = {
    tervrstaprofila_50_ili_70,
    tipkomore,
  };

  //
  // let _arr = [];
  // let _protobomp = protobomp_manipulator.init();
  /*
  let _protobomp = protobomp_manipulator.init(null, {
    // TODO
    ...protobomp_superdata
  });
  */
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$klizac"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_klizac_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC',
    duzina: _duzina_omege, // TODO ???
    klizac_duzina: _duzina_omege, // TODO ???
    klizac_visina: _visina_20_ili_35,
  };
  let _temp_sklop;
  let _temp_pbnode;
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_A',
    klizac_tip: 'A',
    identmaterijala: klizactipa_materijal_lim,
    // naziv: 'KLIZAC TIP A OSNOVNI',
    naziv: 'KLIZAC TIP A IZNAD PANELA',
    kolicina: klizac_kolikoa,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipa } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_tip_kadice: 'S',
    identmaterijala: klizactipb_materijal_lim,
    naziv: 'KLIZAC TIP B IZNAD KADICE STD',
    kolicina: klizac_kolikob,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipb } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_strana_maske: 'LEVI',
    klizac_tip_kadice: 'S',
    identmaterijala: klizactipb_materijal_lim,
    naziv: 'KLIZAC TIP B IZNAD KADICE STD LEVI',
    kolicina: klizac_kolikob_levi,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipb_levi } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_tip_kadice: 'S',
    klizac_strana_maske: 'DESNI',
    identmaterijala: klizactipb_materijal_lim,
    naziv: 'KLIZAC TIP B IZNAD KADICE STD DESNI',
    kolicina: klizac_kolikob_desni,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipb_desni } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_tip_kadice: 'P',
    naziv: 'KLIZAC TIP B IZNAD KADICE PLITKE',
    identmaterijala: klizactipb_materijal_lim,
    kolicina: klizac_kolikobplitka,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipbplitka } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_tip_kadice: 'P',
    klizac_strana_maske: 'LEVI',
    naziv: 'KLIZAC TIP B IZNAD KADICE PLITKE LEVI',
    identmaterijala: klizactipb_materijal_lim,
    kolicina: klizac_kolikobplitka_levi,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipbplitka_levi } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_B',
    klizac_tip: 'B',
    klizac_strana_maske: 'DESNI',
    klizac_tip_kadice: 'P',
    naziv: 'KLIZAC TIP B IZNAD KADICE PLITKE DESNI',
    identmaterijala: klizactipb_materijal_lim,
    kolicina: klizac_kolikobplitka_desni,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipbplitka_desni } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_C',
    klizac_tip: 'C',
    klizac_tip_kadice: 'S',
    naziv: 'KLIZAC TIP C IZNAD KADICE STD',
    identmaterijala: klizactipc_materijal_lim,
    kolicina: klizac_kolikoc,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipc } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_C',
    klizac_tip: 'C',
    klizac_tip_kadice: 'S',
    klizac_strana_maske: 'DA', // 
    naziv: 'KLIZAC TIP C IZNAD KADICE STD SA MASKOM', // Za sklop u paramtere strana maske da ne pise ni KRAJNJI ni desna ni leva nego DA
    identmaterijala: klizactipc_materijal_lim,
    kolicina: klizac_kolikoc_krajnji,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipc_krajnji } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_C',
    klizac_tip: 'C',
    klizac_tip_kadice: 'P',
    naziv: 'KLIZAC TIP C IZNAD KADICE PLITKE',
    identmaterijala: klizactipc_materijal_lim,
    kolicina: klizac_kolikocplitka,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipcplitka } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$klizac/SKLOP_KLIZAC_C',
    klizac_tip: 'C',
    klizac_tip_kadice: 'P',
    klizac_strana_maske: 'DA',
    naziv: 'KLIZAC TIP C IZNAD KADICE PLITKE SA MASKOM', // Za sklop u paramtere strana maske da ne pise ni KRAJNJI ni desna ni leva nego DA
    identmaterijala: klizactipc_materijal_lim,
    kolicina: klizac_kolikocplitka_krajnji,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_klizactipcplitka_krajnji } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //
  // if (klizaciznadcega === 'IZNADPANELA') {
  // sklop_klizactipa
  if (klizac_kolikoa > 0) {
    let item_1;
    if (true) {
      // 1.1 Omega profil (primitivni op. lim)
      const item = {
        tempkey: 101,
        pbnode_family: 'terkk$klizac/LIM_OMEGA_A',
        naziv: "OMEGA_TIP_A ?",
        kolicina: 1,
        identmaterijala: klizactipa_materijal_lim,
        dimenzija1: _duzina_omege,
        dimenzija2: _visina_20_ili_35,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      console.log('Omega item.kolicina', item.kolicina);
      item_1 = { ...item };
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      // if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
      if (_is_klizactipa_dvodelna_varijanta === true) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        item.naziv = "OMEGA_TIP_A ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        item.dimenzija1 = _prepolovljena_duzina;
        // item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
        item.kolicina = _klizactipa_dvodelni_child_kolicina; //
        console.log('item.kolicina', item.kolicina);
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipa);
    }
    if (true) {
      // 1.2 L profil (primitivni op. lim)
      const item = {
        tempkey: 102,
        pbnode_family: 'terkk$klizac/LIM_L_A',
        naziv: "L_TIP_A ?",
        kolicina: 1,
        identmaterijala: klizactipa_materijal_lim,
        dimenzija1: item_1.dimenzija1, // _duzina_omege
        dimenzija2: 0, // NJ: L PROFIL ima neku fiksnu visinu a ako se desi da treba drugacije radice ga kao limcustom.
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      console.log('L item.kolicina', item.kolicina);
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      // if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
      if (_is_klizactipa_dvodelna_varijanta === true) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        item.naziv = "L_TIP_A ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        // item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
        item.kolicina = _klizactipa_dvodelni_child_kolicina; //
        console.log('item.kolicina', item.kolicina);
      }
      console.log('item.kolicina', item.kolicina);
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipa);
    }
  }
  //
  // if (klizaciznadcega === 'IZNADKADICESTANDARD') {
  // sklop_klizactipb
  // sklop_klizactipb_levi
  // sklop_klizactipb_desni
  if (klizac_kolikob > 0 || klizac_kolikob_levi > 0 || klizac_kolikob_desni > 0) {
    let item_omega;
    if (true) {
      // 2.1 Omega profil (primitivni op. lim)
      const item = {
        tempkey: 211,
        pbnode_family: 'terkk$klizac/LIM_OMEGA_B',
        naziv: "OMEGA_TIP_B ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_omege,
        dimenzija2: _visina_20_ili_35,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_omega = { ...item };
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
        item.naziv = "OMEGA_TIP_B ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_desni);
    }
    if (true) {
      // 2.2 L profil (primitivni op. lim)
      const item = {
        tempkey: 212,
        pbnode_family: 'terkk$klizac/LIM_L_B',
        naziv: "L_TIP_B ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: (item_omega.dimenzija1 - 100),
        // Duzina = duzina omega profila - 100 mm 
        // NJ: Svi L profili su fizički isti samo je kod tipa B ili C 100mm kraci nego kod tipa A.
        dimenzija2: 0, // NJ: L PROFIL ima neku fiksnu visinu a ako se desi da treba drugacije radice ga kao limcustom.
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
        item.naziv = "L_TIP_B ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_desni);
    }
    if (true) {
      // 2.3 Maska leva standardna (primitivni op. lim)
      const item = {
        tempkey: 213,
        pbnode_family: 'terkk$klizac/MASKA_B_LEVA',
        naziv: "MASKA_B_LEVA ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_levi);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_desni);
    }
    if (true) {
      // 2.4 Maska desna standardna (primitivni op. lim)
      const item = {
        tempkey: 214,
        pbnode_family: 'terkk$klizac/MASKA_B_DESNA',
        naziv: "MASKA_B_DESNA ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipb_desni);
    }
  }
  //
  // sklop_klizactipbplitka
  // sklop_klizactipbplitka_levi
  // sklop_klizactipbplitka_desni
  if (klizac_kolikobplitka > 0 || klizac_kolikobplitka_levi > 0 || klizac_kolikobplitka_desni > 0) {
    let item_omega;
    if (true) {
      // 2.1 Omega profil (primitivni op. lim)
      const item = {
        tempkey: 221,
        pbnode_family: 'terkk$klizac/LIM_OMEGA_B',
        naziv: "OMEGA_TIP_B ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_omege,
        dimenzija2: _visina_20_ili_35,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_omega = { ...item };
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
        item.naziv = "OMEGA_TIP_B ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_desni);
    }
    if (true) {
      // 2.2 L profil (primitivni op. lim)
      const item = {
        tempkey: 222,
        pbnode_family: 'terkk$klizac/LIM_L_B',
        naziv: "L_TIP_B ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: (item_omega.dimenzija1 - 100), // Duzina = duzina omega profila - 100 mm
        dimenzija2: 0, // NJ: L PROFIL ima neku fiksnu visinu a ako se desi da treba drugacije radice ga kao limcustom.
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine // NOVO 2024-02-06: kada je komora veća od veličine 24 (2440mm)
        item.naziv = "L_TIP_B ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        item.kolicina = item.kolicina * 2; // kolicina za 2 ista dela se uduplava
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_desni);
    }
    if (true) {
      // 2.3 Maska leva plitka (primitivni op. lim)
      const item = {
        tempkey: 223,
        pbnode_family: 'terkk$klizac/MASKA_B_PLITKA_LEVA',
        naziv: "MASKA_B_PLITKA_LEVA ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_levi);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_desni);
    }
    if (true) {
      // 2.4 Maska desna plitka (primitivni op. lim)
      const item = {
        tempkey: 224,
        pbnode_family: 'terkk$klizac/MASKA_B_PLITKA_DESNA',
        naziv: "MASKA_B_PLITKA_DESNA ?",
        kolicina: 1,
        identmaterijala: klizactipb_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_levi);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipbplitka_desni);
    }
  }
  //
  // if (klizaciznadcega === 'IZNADKADICEPLITKE') {
  // sklop_klizactipc
  // sklop_klizactipc_krajnji
  if (klizac_kolikoc > 0 || klizac_kolikoc_krajnji > 0) {
    let item_dole_cev_kvad;
    if (true) {
      // item_dole
      // 2.1 Kvadratni profil cev (primitivni op. profil)
      const item = {
        tempkey: 311,
        pbnode_family: 'terkk$klizac/PROFIL_KVAD_C',
        naziv: "KVAD_TIP_C ?",
        kolicina: 1,
        identmaterijala: klizactipc_materijal_profil,
        duzina: _duzina_omege,
        //
        /*
        // Kod sklopa KLI-iznad kadice-„Tip C Profil Kvad_TIP_C“ kao radni centar potrebno je da ima RC-varioci.
        // Ovo isto nije urađeno ali imam promenu, potrebno je otvoriti mogućnost za odabir u Operacija 1 i neka stoji defaultna operacija OP-Zavarivanje.
        */
        //
        operacija1: "OPZAV",
        rc1: "RCZAV",
      };
      item_dole_cev_kvad = { ...item };
      // item.povrsina
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
    }
    if (true) {
      // item L profil
      // 2.2 L profil (primitivni op. lim)
      let item_jednodelni;
      const item = {
        tempkey: 312,
        pbnode_family: 'terkk$klizac/LIM_L_C',
        naziv: "L_TIP_C ?",
        kolicina: 1,
        identmaterijala: klizactipc_materijal_lim,
        dimenzija1: (item_dole_cev_kvad.duzina - 100), // Duzina = duzina cevi - 100 mm
        dimenzija2: 0, // NJ: L PROFIL ima neku fiksnu visinu a ako se desi da treba drugacije radice ga kao limcustom.
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // PREPOLOVLJAVANJE MEHANIZAM sa prostim deljenjem na pola i dupliranjem kolicine
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        item.naziv = "L_TIP_C ? 1/2";
        const _prepolovljena_duzina = ROUNDDOWN(item_jednodelni.dimenzija1 / 2);
        item.dimenzija1 = _prepolovljena_duzina;
        item.kolicina = item_jednodelni.kolicina * 2; // kolicina za 2 ista dela se uduplava
        // item.ter_koji_deo_visedelnog = '1/2'; //
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
    }

    // MASKA C
    if (true) {
      let item_jednodelni;
      const item = { // XX
        tempkey: 313,
        pbnode_family: 'terkk$klizac/MASKA_C',
        naziv: "MASKA_C ?",
        kolicina: 1, // jedna maska po klizacu
        identmaterijala: klizactipc_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        // operacija2: null,
        // rc2: null,
      };
      item_jednodelni = item;
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) {
          // 2.3 Maska standardna (Ukoliko je duzina veca od 2440 onda ide iz dva dela) (primitivni op. lim)
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$klizac/MASKA_C_1_2',
            naziv: "MASKA_C_1_2 ?",
            // dimenzija1: ROUNDDOWN(_duzina_maske / 2),
            dimenzija1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$klizac/MASKA_C_2_2',
            naziv: "MASKA_C_2_2 ?",
            dimenzija1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        if (true) {
          const item = item_jednodelni;
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
        }
      }
    }


    /////
    if (true) {
      // 2.3 Pločica za montazu (primitivni op. lim)
      const item = {
        tempkey: 315,
        pbnode_family: 'terkk$klizac/LIM_PLOCICA', // TODO
        naziv: "PLOČICA za montažu ???",
        kolicina: 2,
        identmaterijala: klizactipc_materijal_lim_plocica,
        // Dimenzija pločice za cev je 80x33 mm, površina 0,0027m2 i proizvodi se od prohroma debljine 2mm,
        dimenzija1: 88,
        dimenzija2: 33,
        povrsina: 0.0027,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        // operacija2: null,
        // rc2: null,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // iskljucujemo dodavanje kao PRIMITIVNI LIM i prebacujemo da se koristi kao materijal
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
    }
    // TODO plocica kao materijal ???
    if (true) {
      /*
      Pločica kod TIP C Klizača
      PLOCICA KLIZACA C 88x33 potrebno je staviti kao materijal sa sledećim identom "KLIP5000000" i nazivom "Plocica za fiksiranje klizača P01-09-C-P5"
      Koriste se 2 komada po sklopu.
      */
      const item = {
        // tempkey: 140,
        naziv: 'Plocica za fiksiranje klizača P01-09-C-P5',
        kolicina: 2, // NJ: koriste se dve plocice po sklopu.
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: "KLIP5000000",
      };
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipc_krajnji);
    }
  }
  //
  // sklop_klizactipcplitka
  // sklop_klizactipcplitka_krajnji
  if (klizac_kolikocplitka > 0 || klizac_kolikocplitka_krajnji > 0) {
    let item_dole_cev_kvad;
    if (true) {
      // item_dole
      // 2.1 Kvadratni profil cev(primitivni op. profil)
      const item = {
        tempkey: 321,
        pbnode_family: 'terkk$klizac/PROFIL_KVAD_C',
        naziv: "KVAD_TIP_C ?",
        kolicina: 1,
        identmaterijala: klizactipc_materijal_profil,
        duzina: _duzina_omege,
        operacija1: "OPZAV",
        rc1: "RCZAV", // NJ 2024-04-18 Cev na radni centar zavarivanje
        // operacija2: "OPSAV",
        // rc2: "RCPRSER",
      };
      item_dole_cev_kvad = { ...item };
      // item.povrsina
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
    }
    if (true) {
      // 2.2 L profil (primitivni op. lim)
      const item = {
        tempkey: 322,
        pbnode_family: 'terkk$klizac/LIM_L_C',
        naziv: "L_TIP_C ?",
        kolicina: 1,
        identmaterijala: klizactipc_materijal_lim,
        dimenzija1: (item_dole_cev_kvad.duzina - 100), // Duzina = duzina cevi - 100 mm
        dimenzija2: item_dole_cev_kvad.dimenzija2,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
    }

    // maska C PLITKA
    if (true) {
      let item_jednodelni;
      const item = { // XX
        tempkey: 313,
        pbnode_family: 'terkk$klizac/MASKA_C_PLITKA',
        naziv: "MASKA_C_PLITKA ?",
        kolicina: 1, // jedna maska po klizacu
        identmaterijala: klizactipc_materijal_lim,
        dimenzija1: _duzina_maske,
        dimenzija2: _visina_maske,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        // operacija2: null,
        // rc2: null,
      };
      item_jednodelni = item;
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.dimenzija1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
        const _prepolovljena_duzina = ROUNDDOWN(item.dimenzija1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) {
          // 2.3 Maska plitka (Ukoliko je duzina veca od 2440 onda ide iz dva dela) (primitivni op. lim)
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$klizac/MASKA_C_PLITKA_1_2',
            naziv: "MASKA_C_PLITKA_1_2 ?",
            // dimenzija1: ROUNDDOWN(_duzina_maske / 2),
            dimenzija1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          };
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$klizac/MASKA_C_PLITKA_2_2',
            naziv: "MASKA_C_PLITKA_2_2 ?",
            // dimenzija1: ROUNDDOWN(_duzina_maske / 2),
            dimenzija1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        if (true) {
          const item = item_jednodelni;
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
        }
      }
    }

    if (true) {
      // 2.3 Pločica za montazu (primitivni op. lim)
      const item = {
        tempkey: 315,
        pbnode_family: 'terkk$klizac/LIM_PLOCICA', // TODO
        naziv: "? PLOČICA za montažu ???",
        kolicina: 2, // NJ: koriste se dve plocice po sklopu.
        identmaterijala: klizactipc_materijal_lim_plocica,
        // Dimenzija pločice za cev je 80x33 mm, površina 0,0027m2 i proizvodi se od prohroma debljine 2mm,
        dimenzija1: 88,
        dimenzija2: 33,
        povrsina: 0.0027,
        operacija1: "OPSEC",
        rc1: "RCPRBAM", // NJ 2024-04-18 Pločica za sada samo na Amada
        // operacija2: "OPSAV",
        // rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // iskljucujemo dodavanje kao PRIMITIVNI LIM i prebacujemo da se koristi kao materijal
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
    }
    // TODO plocica kao materijal ???
    if (true) {
      /*
      Pločica kod TIP C Klizača
      PLOCICA KLIZACA C 88x33 potrebno je staviti kao materijal sa sledećim identom "KLIP5000000" i nazivom "Plocica za fiksiranje klizača P01-09-C-P5"
      Koriste se 2 komada po sklopu.
      */
      const item = {
        // tempkey: 140,
        naziv: 'Plocica za fiksiranje klizača P01-09-C-P5',
        kolicina: 2, // NJ: koriste se dve plocice po sklopu.
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: "KLIP5000000",
      };
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_klizactipcplitka_krajnji);
    }
  }
  //
  //
  // brisanje viškova
  if (!(klizac_kolikoa > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipa)
  }
  if (!(klizac_kolikob > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipb)
  }
  if (!(klizac_kolikob_desni > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipb_desni)
  }
  if (!(klizac_kolikob_levi > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipb_levi)
  }
  if (!(klizac_kolikobplitka > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipbplitka)
  }
  if (!(klizac_kolikobplitka_desni > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipbplitka_desni)
  }
  if (!(klizac_kolikobplitka_levi > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipbplitka_levi)
  }
  if (!(klizac_kolikoc > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipc)
  }
  if (!(klizac_kolikoc_krajnji > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipc_krajnji)
  }
  if (!(klizac_kolikocplitka > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipcplitka)
  }
  if (!(klizac_kolikocplitka_krajnji > 0)) {
    protobomp_manipulator.delete_pbnode_and_all_descendants(_protobomp, sklop_klizactipcplitka_krajnji)
  }
  //
  return {
    svasta: {
      klizac_kolikoa,
      klizac_kolikob,
      klizac_kolikob_desni,
      klizac_kolikob_levi,
      klizac_kolikobplitka,
      klizac_kolikobplitka_desni,
      klizac_kolikobplitka_levi,
      klizac_kolikoc,
      klizac_kolikocplitka,
    },
    /*
    _arr,
    _subform_arr_subpp_klizactipa,
    _subform_arr_subpp_klizactipb,
    _subform_arr_subpp_klizactipbplitka,
    _subform_arr_subpp_klizactipc,
    _subform_arr_subpp_klizactipcplitka,
    */
    _protobomp,
  };
};


// ---------- VIRBOM DERIVATS ----------
// NE KORISTI SE jer je ovaj draftel prebacen na protobomp koncept

